import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  divider: theme => ({
    width: '100%',
    backgroundColor: theme.colors.dividerThree,
    height: 1,
    marginTop: 14,
  }),
});
